import { createSlice } from "@reduxjs/toolkit";

const editTicketSlice = createSlice({
  name: "editTicket",
  initialState: {
    editTicket: null,
  },
  reducers: {
    setEditTicket: (state, action) => {
      state.editTicket = action.payload;
    },
    clearEditTicket: (state) => {
      state.editTicket = null;
    },
  },
});

export const { setEditTicket, clearEditTicket } = editTicketSlice.actions;

export default editTicketSlice.reducer;
